export default {
  fields: {
    code: 'Cod',
    tag: 'Etichetă',
    type: 'Tip',
    discount_type: 'Tip reducere',
    discount: 'Reducere',
    usage_threshold: 'Prag utilizare',
    quantity: 'Cantitate',
    expires_at: 'Expiră',
    customers: 'Clienți',
    purchases: 'Comenzi',
    sales: 'Vânzări',
    level: 'Nivel',
    max_discount: 'Reducere maximă',
  },
  tags: {
    master: 'Master',
    campaign: 'Campanie',
    one_time: 'O singură dată',
  },
  types: {
    single_use: 'Utilizare unică',
    multi_use: 'Utilizare multiplă',
    unknown: 'Necunoscut',
  },
  discount_types: {
    fixed_amount: 'Sumă fixă',
    percentage: 'Procent',
    unknown: 'Necunoscut',
  },
  labels: {
    discount: 'Reducere',
    usage_threshold: 'Prag utilizare',
    company: 'Companie',
  },
  collecting_emails: {
    description:
      'Aici puteți configura codul promoțional de unică folosință generat pentru utilizatorii noi la înregistrarea pe site.',
  },
  buttons: {
    edit: 'Editează',
  },
  toasts: {
    successfully_deleted: 'Setările codului promoțional au fost șterse cu succes',
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },
};
